/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ConnectionRow } from './connectionRow';

/**
 * One chunk uploaded through a private upload link; ``final`` on the last chunk consumes the link.
 */
export interface UploadLinkConnectionsRequest {
  /**
     * @minItems 1
     * @maxItems 5000
     */
  rows: ConnectionRow[];
  replace?: boolean;
  final?: boolean;
}
